module.exports = {
	"id": "ES",
	"name": "Spain",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.05565,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.01113,
			"19": null,
			"20": null,
			"21": 0.005565,
			"22": 0.027825,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.016695,
			"27": 0.005565,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.027825,
			"32": 0.01113,
			"33": 0.016695,
			"34": 0.03339,
			"35": 0.03339,
			"36": 0.03339,
			"37": 0.027825,
			"38": 0.050085,
			"39": 0.06678,
			"40": 0.04452,
			"41": 0.038955,
			"42": 0.038955,
			"43": 0.094605,
			"44": 0.06678,
			"45": 0.083475,
			"46": 0.094605,
			"47": 0.083475,
			"48": 0.1113,
			"49": 2.76024,
			"50": 0.127995,
			"51": 0.484155,
			"52": 0.38955,
			"53": 21.786975,
			"54": 5.48709,
			"55": 0.038955,
			"56": 0.01113,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.01113,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.016695,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.027825,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.016695,
			"25": 0.005565,
			"26": 0.01113,
			"27": 0.005565,
			"28": 0.01113,
			"29": 0.016695,
			"30": 0.01113,
			"31": 0.027825,
			"32": 0.02226,
			"33": 0.02226,
			"34": 0.027825,
			"35": 0.03339,
			"36": 0.02226,
			"37": 0.038955,
			"38": 0.12243,
			"39": 0.061215,
			"40": 0.03339,
			"41": 0.04452,
			"42": 0.050085,
			"43": 0.127995,
			"44": 0.06678,
			"45": 0.17808,
			"46": 0.08904,
			"47": 0.517545,
			"48": 0.651105,
			"49": 7.44597,
			"50": 0.03339,
			"51": 0.005565,
			"52": null,
			"3.5": null,
			"3.6": 0.02226
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.038955,
			"37": 0.027825,
			"38": 0.03339,
			"39": 0.01113,
			"40": 0.26712,
			"41": 0.04452,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.02226
		},
		"safari": {
			"0": null,
			"4": 0.01113,
			"5": 0.04452,
			"6": 0.01113,
			"7": 0.03339,
			"8": 0.18921,
			"9": 0.361725,
			"10": 2.09244,
			"3.1": null,
			"3.2": null,
			"5.1": 0.10017,
			"6.1": 0.072345,
			"7.1": 0.016695,
			"9.1": 1.407945
		},
		"ios_saf": {
			"8": 0,
			"10": 6.26966459617,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.168960206078,
			"8.1-8.4": 0.312146821399,
			"9.0-9.2": 0.148914079933,
			"9.3": 2.27189429642
		},
		"android": {
			"3": 0,
			"4": 0.0409922351421,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00512402939276,
			"4.1": 0.147864848191,
			"4.2-4.3": 0.369662120478,
			"4.4": 0.847660862403,
			"4.4.3-4.4.4": 0.854980904393
		},
		"ie": {
			"6": 0.00559540983607,
			"7": 0.0111908196721,
			"8": 0.307747540984,
			"9": 0.195839344262,
			"10": 0.151076065574,
			"11": 3.42439081967,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00825793195353,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000229386998709
		},
		"edge": {
			"12": 0.06678,
			"13": 0.428505,
			"14": 1.263255
		},
		"ie_mob": {
			"10": 0.0734585915493,
			"11": 0.299081408451
		},
		"bb": {
			"7": 0.0110875,
			"10": null
		},
		"samsung": {
			"0": 2.82953
		},
		"and_uc": {
			"0": 0.0887
		},
		"op_mini": {
			"0": 0.111257681048
		},
		"and_chr": {
			"0": 31.49796
		},
		"and_ff": {
			"0": 0.031045
		}
	},
	"total": 98.9721575
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/ES.json
 ** module id = 516
 ** module chunks = 0
 **/